/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AiSummaryResponse } from '../models/AiSummaryResponse';
import type { CreatePatient } from '../models/CreatePatient';
import type { CreateVisitRecordSchema } from '../models/CreateVisitRecordSchema';
import type { NextAppointmentSchema } from '../models/NextAppointmentSchema';
import type { NextAppointmentUpdateSchema } from '../models/NextAppointmentUpdateSchema';
import type { PagedListPatient } from '../models/PagedListPatient';
import type { PagedPatientSuggestionSchema } from '../models/PagedPatientSuggestionSchema';
import type { PagedPatientTicketListSchema } from '../models/PagedPatientTicketListSchema';
import type { PagedPatientVisitImageListSchema } from '../models/PagedPatientVisitImageListSchema';
import type { PagedVisitListSchema } from '../models/PagedVisitListSchema';
import type { PatchPatient } from '../models/PatchPatient';
import type { PatientBulkEmailSchema } from '../models/PatientBulkEmailSchema';
import type { PatientBulkSmsSchema } from '../models/PatientBulkSmsSchema';
import type { PatientDetailSchema } from '../models/PatientDetailSchema';
import type { PatientEmailSchema } from '../models/PatientEmailSchema';
import type { PatientMedicalReportSchema } from '../models/PatientMedicalReportSchema';
import type { PatientSchema } from '../models/PatientSchema';
import type { PatientSchemaPatientCount } from '../models/PatientSchemaPatientCount';
import type { PatientSmsSchema } from '../models/PatientSmsSchema';
import type { SelectedPatientsFilterSchema } from '../models/SelectedPatientsFilterSchema';
import type { UpdatePatient } from '../models/UpdatePatient';
import type { VisitDetailSchema } from '../models/VisitDetailSchema';
import type { VisitFormSchema } from '../models/VisitFormSchema';
import type { VisitImageSchema } from '../models/VisitImageSchema';
import type { VisitSummaryRequest } from '../models/VisitSummaryRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PatientsApi {
    /**
     * Add Patient
     * Add new patient. <br>Required Permission: create_patient
     * @returns PatientSchemaPatientCount Created
     * @throws ApiError
     */
    public static patientsAddPatientPost({
        requestBody,
    }: {
        requestBody: CreatePatient,
    }): CancelablePromise<PatientSchemaPatientCount> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/patients/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Patient List
     * Get list of patients.<br> Use name to filter in name only and search to fulltext search (name, email, phone etc.)<br>Use order to sort by field (ASC name, email, phone or DESC prepend '-' to field name)<br>Required permission: list_patients
     * @returns PagedListPatient OK
     * @throws ApiError
     */
    public static patientsGetPatientListGet({
        name = '',
        search = '',
        order,
        waiting = false,
        visitsFrom,
        visitsTo,
        serviceIds,
        userIds,
        hasPhone,
        receiveNewsletterConsent,
        patientNotCome,
        hasUnpaidVisit,
        insuranceCompanyCodes,
        groupVisitId,
        substitute,
        patientTagIds,
        visitTagIds,
        subscriptionId,
        limit = 100,
        offset,
    }: {
        name?: string,
        search?: string,
        order?: ('name' | '-name' | 'email' | '-email' | 'phone' | '-phone' | 'birth_date' | '-birth_date' | 'next_visit_date' | '-next_visit_date' | 'last_visit_date' | '-last_visit_date' | 'waiting' | '-waiting' | 'waiting_service' | '-waiting_service' | 'waiting_user' | '-waiting_user' | 'birth_number' | '-birth_number' | null),
        waiting?: boolean,
        visitsFrom?: (string | null),
        visitsTo?: (string | null),
        serviceIds?: (Array<string> | null),
        userIds?: (Array<string> | null),
        hasPhone?: (boolean | null),
        receiveNewsletterConsent?: (boolean | null),
        patientNotCome?: (boolean | null),
        hasUnpaidVisit?: (boolean | null),
        insuranceCompanyCodes?: (Array<string> | null),
        groupVisitId?: (string | null),
        substitute?: (boolean | null),
        patientTagIds?: (Array<string> | null),
        visitTagIds?: (Array<string> | null),
        subscriptionId?: (string | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedListPatient> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/patients/',
            query: {
                'name': name,
                'search': search,
                'order': order,
                'waiting': waiting,
                'visits_from': visitsFrom,
                'visits_to': visitsTo,
                'service_ids': serviceIds,
                'user_ids': userIds,
                'has_phone': hasPhone,
                'receive_newsletter_consent': receiveNewsletterConsent,
                'patient_not_come': patientNotCome,
                'has_unpaid_visit': hasUnpaidVisit,
                'insurance_company_codes': insuranceCompanyCodes,
                'group_visit_id': groupVisitId,
                'substitute': substitute,
                'patient_tag_ids': patientTagIds,
                'visit_tag_ids': visitTagIds,
                'subscription_id': subscriptionId,
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * Create Patient Visit Record
     * Create a dekurz-only visit record for a patient. Service, room and datetime are resolved on the server; the record stays out of the calendar and the classic visit list but is visible in patient visits. <br>Required Permission: create_visit
     * @returns VisitDetailSchema Created
     * @throws ApiError
     */
    public static patientsCreatePatientVisitRecordPost({
        patientId,
        requestBody,
    }: {
        patientId: string,
        requestBody: CreateVisitRecordSchema,
    }): CancelablePromise<VisitDetailSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/patients/{patient_id}/visit-records/',
            path: {
                'patient_id': patientId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Patient Card Pdfs Export
     * @returns void
     * @throws ApiError
     */
    public static patientsGetPatientCardPdfsExportPost({
        requestBody,
    }: {
        requestBody: SelectedPatientsFilterSchema,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/patients/patient-card-pdf-export/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Patient Medical Report Pdf
     * @returns any Created
     * @throws ApiError
     */
    public static patientsGetPatientMedicalReportPdfPost({
        patientId,
        requestBody,
    }: {
        patientId: string,
        requestBody: PatientMedicalReportSchema,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/patients/{patient_id}/patient-medical-report/',
            path: {
                'patient_id': patientId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Send Patient Bulk Email
     * Send patient bulk email. <br>Required permission: send_patient_email
     * @returns void
     * @throws ApiError
     */
    public static patientsSendPatientBulkEmailPost({
        requestBody,
    }: {
        requestBody: PatientBulkEmailSchema,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/patients/send-bulk-email/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Send Patient Bulk Sms
     * Send custom sms message to patient. <br>Required Permission: send_patient_sms
     * @returns void
     * @throws ApiError
     */
    public static patientsSendPatientBulkSmsPost({
        requestBody,
    }: {
        requestBody: PatientBulkSmsSchema,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/patients/send-bulk-sms/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Send Patient Email
     * Send patient email. <br>Required permission: send_patient_email
     * @returns any OK
     * @throws ApiError
     */
    public static patientsSendPatientEmailPost({
        requestBody,
    }: {
        requestBody: PatientEmailSchema,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/patients/send-email/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Send Patient Sms
     * Send custom sms message to patient. <br>Required Permission: send_patient_sms
     * @returns boolean Created
     * @throws ApiError
     */
    public static patientsSendPatientSmsPost({
        requestBody,
    }: {
        requestBody: PatientSmsSchema,
    }): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/patients/send-sms/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Patient Ticket List For Patient
     * Get list of active assigned tickets for given patient. If expired is True, return expired tickets as well. <br>Required permission: list_patient_tickets
     * @returns PagedPatientTicketListSchema OK
     * @throws ApiError
     */
    public static patientsGetPatientTicketListForPatientGet({
        patientId,
        orderBy,
        expired = false,
        limit = 100,
        offset,
    }: {
        patientId: string,
        orderBy?: (string | null),
        expired?: boolean,
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedPatientTicketListSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/patients/{patient_id}/patient-ticket-list/',
            path: {
                'patient_id': patientId,
            },
            query: {
                'order_by': orderBy,
                'expired': expired,
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * Get Patient Visit Forms
     * Get patient visit forms. <br>Required Permission: 'get_patient_detail'
     * @returns VisitFormSchema OK
     * @throws ApiError
     */
    public static patientsGetPatientVisitFormsGet({
        patientId,
    }: {
        patientId: string,
    }): CancelablePromise<Array<VisitFormSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/patients/{patient_id}/visit-forms/',
            path: {
                'patient_id': patientId,
            },
        });
    }
    /**
     * Get Patient Visit Image List
     * Get patient visit images. <br>Required Permission: 'get_patient_detail'
     * @returns PagedPatientVisitImageListSchema OK
     * @throws ApiError
     */
    public static patientsGetPatientVisitImageListGet({
        patientId,
        dateFrom,
        dateTo,
        limit = 100,
        offset,
    }: {
        patientId: string,
        dateFrom?: (string | null),
        dateTo?: (string | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedPatientVisitImageListSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/patients/{patient_id}/visit-images/',
            path: {
                'patient_id': patientId,
            },
            query: {
                'date_from': dateFrom,
                'date_to': dateTo,
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * Get Patient Visits
     * List patients.<br>Required permission: list_visits
     * @returns PagedVisitListSchema OK
     * @throws ApiError
     */
    public static patientsGetPatientVisitsGet({
        patientId,
        toDate,
        fromDate,
        limit = 100,
        offset,
    }: {
        patientId: string,
        toDate?: (string | null),
        fromDate?: (string | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedVisitListSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/patients/{patient_id}/visits/',
            path: {
                'patient_id': patientId,
            },
            query: {
                'to_date': toDate,
                'from_date': fromDate,
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * Get Patient Suggestion
     * Get suggestion of patients name. Use name to filter in name only.<br>Required permission: list_patients
     * @returns PagedPatientSuggestionSchema OK
     * @throws ApiError
     */
    public static patientsGetPatientSuggestionGet({
        name,
        limit = 100,
        offset,
    }: {
        name: string,
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedPatientSuggestionSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/patients/suggestion/',
            query: {
                'name': name,
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * Get Patient
     * Get patient detail. <br>Required Permission: 'get_patient_detail'
     * @returns PatientDetailSchema OK
     * @throws ApiError
     */
    public static patientsGetPatientGet({
        patientId,
    }: {
        patientId: string,
    }): CancelablePromise<PatientDetailSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/patients/{patient_id}/',
            path: {
                'patient_id': patientId,
            },
        });
    }
    /**
     * Update Patient
     * Update patient. <br>Required Permission: update_patient
     * @returns PatientSchema OK
     * @throws ApiError
     */
    public static patientsUpdatePatientPut({
        patientId,
        requestBody,
    }: {
        patientId: string,
        requestBody: UpdatePatient,
    }): CancelablePromise<PatientSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/patients/{patient_id}/',
            path: {
                'patient_id': patientId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Patch Patient
     * Patch patient. Required Permission: update_patient
     * @returns PatientSchema OK
     * @throws ApiError
     */
    public static patientsPatchPatientPatch({
        patientId,
        requestBody,
    }: {
        patientId: string,
        requestBody: PatchPatient,
    }): CancelablePromise<PatientSchema> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/patients/{patient_id}/',
            path: {
                'patient_id': patientId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete Patient
     * Delete patient. <br>Required Permission: remove_patient
     * @returns void
     * @throws ApiError
     */
    public static patientsDeletePatientDelete({
        patientId,
    }: {
        patientId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/patients/{patient_id}/',
            path: {
                'patient_id': patientId,
            },
        });
    }
    /**
     * Merge Patients
     * Merge patient. <br>Required Permission: merge_patients
     * @returns void
     * @throws ApiError
     */
    public static patientsMergePatientsPatch({
        sourcePatientId,
        targetPatientId,
    }: {
        sourcePatientId: string,
        targetPatientId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/patients/merge/{source_patient_id}/{target_patient_id}',
            path: {
                'source_patient_id': sourcePatientId,
                'target_patient_id': targetPatientId,
            },
        });
    }
    /**
     * Upload Patient Form
     * Upload patient form. <br>Required Permission: update_patient
     * @returns VisitFormSchema Created
     * @throws ApiError
     */
    public static patientsUploadPatientFormPost({
        patientId,
        formData,
    }: {
        patientId: string,
        formData: {
            file: Blob;
        },
    }): CancelablePromise<VisitFormSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/patients/{patient_id}/patient-forms/',
            path: {
                'patient_id': patientId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Upload Patient Image
     * Upload patient image. <br>Required Permission: update_patient
     * @returns VisitImageSchema Created
     * @throws ApiError
     */
    public static patientsUploadPatientImagePost({
        patientId,
        formData,
    }: {
        patientId: string,
        formData: {
            image: Blob;
        },
    }): CancelablePromise<VisitImageSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/patients/{patient_id}/patient-images/',
            path: {
                'patient_id': patientId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Generate Patients And Visits Export
     * Generate export of patients. <br>Required Permission: export_patients <br>If query parameter include_visits is true, than patient visits are included on separate sheet. <br>Required Permission: export_patients_and_visits
     * @returns any Accepted
     * @throws ApiError
     */
    public static patientsGeneratePatientsAndVisitsExportGet({
        includeVisits = true,
        name = '',
        search = '',
        order,
        waiting = false,
        visitsFrom,
        visitsTo,
        serviceIds,
        userIds,
        hasPhone,
        receiveNewsletterConsent,
        patientNotCome,
        hasUnpaidVisit,
        insuranceCompanyCodes,
        groupVisitId,
        substitute,
        patientTagIds,
        visitTagIds,
        subscriptionId,
        patientIds,
    }: {
        includeVisits?: boolean,
        name?: string,
        search?: string,
        order?: ('name' | '-name' | 'email' | '-email' | 'phone' | '-phone' | 'birth_date' | '-birth_date' | 'next_visit_date' | '-next_visit_date' | 'last_visit_date' | '-last_visit_date' | 'waiting' | '-waiting' | 'waiting_service' | '-waiting_service' | 'waiting_user' | '-waiting_user' | 'birth_number' | '-birth_number' | null),
        waiting?: boolean,
        visitsFrom?: (string | null),
        visitsTo?: (string | null),
        serviceIds?: (Array<string> | null),
        userIds?: (Array<string> | null),
        hasPhone?: (boolean | null),
        receiveNewsletterConsent?: (boolean | null),
        patientNotCome?: (boolean | null),
        hasUnpaidVisit?: (boolean | null),
        insuranceCompanyCodes?: (Array<string> | null),
        groupVisitId?: (string | null),
        substitute?: (boolean | null),
        patientTagIds?: (Array<string> | null),
        visitTagIds?: (Array<string> | null),
        subscriptionId?: (string | null),
        patientIds?: Array<string>,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/patients/export',
            query: {
                'include_visits': includeVisits,
                'name': name,
                'search': search,
                'order': order,
                'waiting': waiting,
                'visits_from': visitsFrom,
                'visits_to': visitsTo,
                'service_ids': serviceIds,
                'user_ids': userIds,
                'has_phone': hasPhone,
                'receive_newsletter_consent': receiveNewsletterConsent,
                'patient_not_come': patientNotCome,
                'has_unpaid_visit': hasUnpaidVisit,
                'insurance_company_codes': insuranceCompanyCodes,
                'group_visit_id': groupVisitId,
                'substitute': substitute,
                'patient_tag_ids': patientTagIds,
                'visit_tag_ids': visitTagIds,
                'subscription_id': subscriptionId,
                'patient_ids': patientIds,
            },
        });
    }
    /**
     * Get Patient Ai Summary
     * Generate an AI summary of patient visits. Requires AI features to be enabled in company settings.
     * @returns AiSummaryResponse OK
     * @throws ApiError
     */
    public static patientsGetPatientAiSummaryPost({
        patientId,
        requestBody,
    }: {
        patientId: string,
        requestBody: VisitSummaryRequest,
    }): CancelablePromise<AiSummaryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/patients/{patient_id}/visits/ai-summary/',
            path: {
                'patient_id': patientId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Patient Next Appointment
     * Get patients next appointment. <br>Required Permission: 'get_patient_detail'
     * @returns NextAppointmentSchema OK
     * @throws ApiError
     */
    public static visitsGetPatientNextAppointmentGet({
        patientId,
    }: {
        patientId: string,
    }): CancelablePromise<NextAppointmentSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/patients/{patient_id}/next-appointment/',
            path: {
                'patient_id': patientId,
            },
        });
    }
    /**
     * Update Patient Next Appointment
     * Update patient's next appointment.
     * @returns NextAppointmentSchema OK
     * @throws ApiError
     */
    public static visitsUpdatePatientNextAppointmentPut({
        patientId,
        requestBody,
    }: {
        patientId: string,
        requestBody: NextAppointmentUpdateSchema,
    }): CancelablePromise<NextAppointmentSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/patients/{patient_id}/next-appointment/',
            path: {
                'patient_id': patientId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
